import React, { Component } from "react";
import {
    Panel,
    Row,
    Col,
    ControlLabel,
    FormControl,
    Button
} from "react-bootstrap";
import DateTime           from "react-datetime";
import                         "style/react-datetime.css";
import moment             from "moment";
import {
    ToastContainer,
    toast
}                           from "react-toastify";
import                           "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import JSONPretty from 'react-json-pretty';

import {
    IS_VALID,
    IS_LENGTH_ZERO
}                           from "utils";

export default class PointsWallet extends Component {
    constructor (props) {
        super(props);

        this.state = {
            memberId: "",
            tddStart: "",
            tddEnd: "",

            isLoadingAction: false,

            result: "",

            voucherTransactionTypes: [],

            pointsPerPlayType: ""
        };

        this.submit = this.submit.bind(this);
    }

    submit () {
        let {
            memberId,
            tddStart,
            tddEnd,

            isLoadingAction,

            voucherTransactionTypes
        } = this.state;

        if (
            !IS_VALID() &&
            !IS_VALID(memberId.trim())
        ) {
            toast.error("Member ID is required.");
        } else if (
            !IS_VALID(tddStart)
        ) {
            toast.error("TDD Start is required.");
        } else if (
            !moment(tddStart, "MMM DD, YYYY", true).isValid()
        ) {
            toast.error("Please select a valid TDD Start.");
        } else if (
            !IS_VALID(tddEnd)
        ) {
            toast.error("TDD End is required.");
        } else if (
            !moment(tddEnd, "MMM DD, YYYY", true).isValid()
        ) {
            toast.error("Please select a valid TDD End.");
        } else {
            this.setState({
                isLoadingAction: true
            });

            axios.post(
                "https://nwrma.newportworldresorts.com/api/voucher/points", // "/api/voucher/points",
                {
                    username: "rwmuser",
                    userkey: "pointswallet123456",
                    cid: memberId.trim(),
                    dateFrom: moment(tddStart, "MMM DD, YYYY").format("YYYY-MM-DD"),
                    dateTo: moment(tddEnd, "MMM DD, YYYY").format("YYYY-MM-DD")
                }
            )
            .then((res) => {
                let isResponseValid = (
                    IS_VALID(res) &&
                    IS_VALID(res.data) &&
                    IS_VALID(res.data.data) &&
                    IS_VALID(res.data.data.response) &&
                    Array.isArray(res.data.data.response)
                );

                let total = (name, playType = "", transType = [], isTransTypeEnabled = false, isNegativeIncluded = false) => {
                    let totalPoints = 0;

                    if (
                      isResponseValid &&
                      !IS_LENGTH_ZERO(res.data.data.response)
                    ) {
                      for (let item of res.data.data.response) {
                        if (
                          IS_VALID(item[name]) &&
                          IS_VALID(item.play_type) &&
                          item.play_type.toUpperCase() === playType.toUpperCase() &&
                          (
                            !isTransTypeEnabled ||
                            (
                                IS_VALID(item.tran_type) &&
                                transType.indexOf(item.tran_type.toUpperCase().trim()) !== -1
                            )
                          )
                        ) {
                          let point = parseFloat(item[name]);

                          if (!isNaN(point)) {
                            if (
                              isNegativeIncluded &&
                              point < 0
                            ) {
                              totalPoints += point
                            } else if (point >= 0) {
                              totalPoints += point;
                            }
                          }
                        }
                      }
                    }

                    return totalPoints < 0 ? 0 : (+totalPoints.toFixed());
                };

                let pointsPerPlayType = {};

                for (let voucherTransactionType of voucherTransactionTypes) {
                    let playType = IS_VALID(voucherTransactionType.get("shortName")) ? voucherTransactionType.get("shortName") : voucherTransactionType.get("name"),
                    transType = Array.isArray(voucherTransactionType.get("transType")) ? voucherTransactionType.get("transType") : [],
                    isTransTypeEnabled = IS_VALID(voucherTransactionType.get("isTransTypeEnabled")) ? voucherTransactionType.get("isTransTypeEnabled") : false,
                    isNegativeIncluded = IS_VALID(voucherTransactionType.get("isNegativeIncluded")) ? voucherTransactionType.get("isNegativeIncluded") : false;

                    pointsPerPlayType[playType] = {
                        mp: parseInt(total("loyalty", playType, transType, isTransTypeEnabled, isNegativeIncluded)),
                        gp: parseInt(total("visual", playType, transType, isTransTypeEnabled, isNegativeIncluded)),
                        tp: parseInt(total("tier", playType, transType, isTransTypeEnabled, isNegativeIncluded)),
                        isNegativeIncluded
                    };
                }
                this.setState({
                    isLoadingAction: false,

                    result: res.data,
                    pointsPerPlayType
                });
            })
            .catch((error) => {
                console.log("submit error");
                console.log(error);

                let errorResponse = error.message;

                if (
                    error.response
                ) {
                    errorResponse = error.response.data;
                }

                this.setState({
                    isLoadingAction: false,

                    result: errorResponse
                });
            });
        }
    }

    getVoucherTransactionType () {
        let voucherTransactionType = new Parse.Query("VoucherTransactionType");

        voucherTransactionType.ascending("shortName");

        voucherTransactionType.find()
        .then((data) => {
            this.setState({
                voucherTransactionTypes: data
            });
        })
        .catch((err) => {
            console.log("getVoucherTransactionType error");
            console.log(err);
        });
    }

    render () {
        let {
            memberId,
            tddStart,
            tddEnd,

            isLoadingAction,

            result,

            pointsPerPlayType
        } = this.state;

        const space = {
			paddingTop: '10px',
			paddingBottom: '10px'
		};

        return (
            <Panel>
                <Panel.Heading
                    style={{
                        backgroundColor: '#D1282F',
                        color: 'white'
                        }}
                >
                    <h4>POINTS WALLET</h4>
                </Panel.Heading>
                <Panel.Body
                    style={{
                        padding: '30px 50px 30px 50px'
                    }}
                >
                    <Row>
                        <Col
                            md={6}
                            mdOffset={3}
                        >
                            <Row style={space}>
                                <Col md={4}>
                                    <ControlLabel>
                                        Member ID
                                    </ControlLabel>
                                </Col>
                                <Col md={6}>
                                    <FormControl
                                        type="text"
                                        value={memberId}
                                        onChange={(e) => {
                                            this.setState({
                                                memberId: e.target.value
                                            });
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row style={space}>
                                <Col md={4}>
                                    <ControlLabel>
                                        TDD Start
                                    </ControlLabel>
                                </Col>
                                <Col md={6}>
                                    <DateTime
                                        dateFormat="MMM DD, YYYY"
                                        timeFormat={false}
                                        value={tddStart}
                                        onChange={(datetime) => {
                                            this.setState({ tddStart: datetime });
                                        }}
                                        inputProps={{
                                            placeholder: "TDD Start"
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row style={space}>
                                <Col md={4}>
                                    <ControlLabel>
                                        TDD End
                                    </ControlLabel>
                                </Col>
                                <Col md={6}>
                                    <DateTime
                                        dateFormat="MMM DD, YYYY"
                                        timeFormat={false}
                                        value={tddEnd}
                                        onChange={(datetime) => {
                                            this.setState({ tddEnd: datetime });
                                        }}
                                        inputProps={{
                                            placeholder: "TDD End"
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row style={space}>
                                <Col md={12} style={{ textAlign: "center" }}>
                                    <Button
                                        bsStyle="primary"
                                        onClick={() => {
                                            this.submit();
                                        }}
                                    >
                                        {isLoadingAction ? (
                                            <span><i style={{ color: "white" }} className="fa fa-spinner fa-spin" /> </span>
                                        ) : (
                                            ""
                                        )}
                                        SUBMIT
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <br/>
                    <br/>
                    <Row>
                        <Col md={12}>
                            <ControlLabel>
                                Points per Play type
                            </ControlLabel>
                            <JSONPretty id="json-pretty" data={isLoadingAction ? "Loading..." : pointsPerPlayType}></JSONPretty>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <ControlLabel>
                                Result
                            </ControlLabel>
                            <JSONPretty id="json-pretty" data={isLoadingAction ? "Loading..." : result}></JSONPretty>
                        </Col>
                    </Row>
                </Panel.Body>
                <ToastContainer/>
            </Panel>
        );
    }

    componentDidMount () {
        this.getVoucherTransactionType();
    }
}



// WEBPACK FOOTER //
// ./components/PointsWallet/index.js